import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity, View } from 'react-native';
import { IconSvg } from 'src/assets';
import { TransitProps } from 'src/common/api/response';
import { Container, RegularText, Row, SizedBox } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { fontSizes, metrics, pixelScaler } from 'src/themes/Metrics';
import styled from 'styled-components/native';

const Styled = {
  Circle: styled.View`
    width: ${pixelScaler(14)}px;
    height: ${pixelScaler(14)}px;
    margin-horizontal: ${pixelScaler(2)}px;
    border-radius: 10px;
    background-color: ${AppColors.gray};
  `,
  SmallLine: styled.View`
    width: 2px;
    height: 50%;
    border-color: ${AppColors.border};
    border-width: 1px;
  `,
  Line: styled.View`
    width: 1px;
    flex: 1;
    border-color: ${AppColors.border};
    border-width: 1px;
  `,
};

export const TimeLine = ({ transits, showMinimal }: { transits: TransitProps[]; showMinimal?: boolean }) => {
  const { t } = useTranslation();
  // const [isVisible, setVisible] = React.useState<boolean>(false);
  // const [latlng, setLatlng] = React.useState({
  //   center: {
  //     lat: 10.99835602,
  //     lng: 77.01502627,
  //   },s
  //   zoom: 11,
  // });
  // const [marker, setMarker] = React.useState({
  //   lat: 10.99835602,
  //   lng: 77.01502627,
  // });

  // const handleClose = () => setVisible(false);

  const handleShowMapPress = (timeline: TransitProps) => {
    window?.nham24?.request(
      'consolelog',
      `https://www.google.com/maps?z=12&q=${timeline.latitude}+${timeline.longitude}`,
    );
    window?.nham24?.request('app/open-link', {
      url: `https://www.google.com/maps?z=12&q=${timeline.latitude}+${timeline.longitude}`,
      // url: `https://www.google.com/maps/place/Anik+Boutique+Hotel+%26+Spa+on+Norodom+Blvd/@11.57687,104.9159783,17z/data=!4m6!3m5!1s0x3109515d912d7c53:0x25c33bd1b35d4c17!8m2!3d11.5804489!4d104.9166099!16s%2Fg%2F11h9gtvppr`,
    });
    // Linking.openURL(`https://www.google.com/maps/?z=12&q=${timeline.latitude}+${timeline.longitude}`);
    // setLatlng(prev => ({
    //   ...prev,
    //   center: {
    //     lat: timeline.latitude,
    //     lng: timeline.longitude,
    //   },
    // }));
    // setMarker({
    //   lat: timeline.latitude,
    //   lng: timeline.longitude,
    // });
    // setVisible(true);
  };

  const renderPoint = (index: number) => {
    if (index !== transits.length - 1) {
      return (
        <Container align="center" width={pixelScaler(18)}>
          <IconSvg.LoginOrigin />
        </Container>
      );
    }

    return (
      <Container align="center" width={pixelScaler(18)}>
        <IconSvg.LoginDestination />
      </Container>
    );
  };

  return (
    <Container width="100%">
      {transits.map((timeline, index) => {
        return (
          <Row height={showMinimal ? pixelScaler(30) : pixelScaler(46)} width="100%" key={index.toString()}>
            <Container style={{ alignItems: 'center' }} marginRight={metrics.small}>
              {renderPoint(index)}
              {index < transits.length - 1 ? <Styled.Line /> : <View />}
            </Container>
            <Container flex paddingLeft={metrics.small}>
              {/* {index === 0 || index === transits.length - 1 ? ( */}
              <Row>
                <Container flex align="middle">
                  <RegularText>{timeline.location.name}</RegularText>
                  {/* {index === transits.length - 1 && (
                      <RegularText fontWeight="bold">{timeline.location.name}</RegularText>
                    )} */}
                </Container>
                {!showMinimal && (
                  <TouchableOpacity
                    activeOpacity={0.8}
                    style={{ flexDirection: 'row', alignItems: 'center' }}
                    onPress={() => handleShowMapPress(timeline)}>
                    {/* <Ionicons name="map" color={AppColors.blue} /> */}
                    <IconSvg.ViewMap />
                    <SizedBox width="small" />
                    <RegularText fontSize={fontSizes.medium}>{t('viewMap')}</RegularText>
                  </TouchableOpacity>
                )}
              </Row>
              {/* ) : (
                <Container />
              )} */}
              {!showMinimal && (
                <RegularText color={AppColors.gray} fontSize="medium">
                  {timeline.stationName}
                </RegularText>
              )}
            </Container>
          </Row>
        );
      })}

      {/* <MapModal center={latlng} marker={marker} isVisible={isVisible} onClose={handleClose} /> */}
    </Container>
  );
};

export const ShortTimeLine = ({ transits }: { transits: { province: string }[] }) => {
  const renderPoint = (index: number) => {
    if (index === 0) {
      return (
        <Container align="center" width={pixelScaler(18)}>
          <IconSvg.LoginOrigin />
        </Container>
      );
    }

    return (
      <Container align="center" width={pixelScaler(18)}>
        <IconSvg.LoginDestination />
      </Container>
    );
  };

  return (
    <Container width="100%">
      {transits.map((timeline, index) => {
        return (
          <Row width="100%" key={index.toString()}>
            <Container style={{ alignItems: 'center' }} marginRight={metrics.medium}>
              {renderPoint(index)}
              {index < transits.length - 1 ? <Styled.SmallLine /> : <View />}
            </Container>
            <Container paddingBottom={metrics.large} flex>
              <RegularText>{timeline.province}</RegularText>
            </Container>
          </Row>
        );
      })}
    </Container>
  );
};

export const ShortHorizontalTimeLine = ({
  origin,
  destination,
}: {
  origin: { province: string };
  destination: { province: string };
}) => {
  return (
    <Row width="100%" paddingVertical={metrics.medium}>
      <Container paddingRight={metrics.tiny}>
        <IconSvg.LoginDestination />
      </Container>
      <SizedBox width="medium" />
      <RegularText>{origin.province}</RegularText>
      <Container marginLeft={metrics.small}>
        <IconSvg.HeaderPointer fill={AppColors.lighterGray} />
      </Container>
      <RegularText>{destination.province}</RegularText>
    </Row>
  );
};
